module.exports = __webpack_public_path__ + "assets/img/loading.89617f2d.gif";